/*! @azure/msal-common v15.5.1 2025-04-16 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.5.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
